import dayjs from 'dayjs';
import { FC } from 'react';
import { HeaderProps } from 'react-big-calendar';

import dateService from '@gem/services/date-service';
import { isRussianLocale } from '@gem/utils';

import { capitalizeFirstLetter } from 'APP/utils/calendar/capitalizeFirstLetter';
import { getLanguage } from 'APP/utils/getLanguage';

interface IDayHeaderProps {
  isCompact?: boolean;
}

export const makeDayHeader = (props: IDayHeaderProps): FC<HeaderProps> => {
  const component: FC<HeaderProps> = ({ date }) => {
    if (props.isCompact) {
      return null;
    }

    const dayNameShort = dateService.format(date, { weekday: 'short' });
    return (
      <>
        <div className="day-name-header">
          {isRussianLocale(getLanguage())
            ? capitalizeFirstLetter(dayNameShort, getLanguage())
            : dayNameShort}
        </div>
        <div className="day-number-header">{dayjs(date).format('D')}</div>
      </>
    );
  };

  return component;
};
